import {
    MODIFY_PRODUCTO_DE_ZONA,
    ADD_PRODUCTO_DE_ZONA,
    DELETE_PRODUCTO_DE_ZONA,
} from '../constants/action_types';


export function modifyProductoDeZona(producto) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_PRODUCTO_DE_ZONA, payload: producto });
    }
}

export function addProductoDeZona(producto) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_PRODUCTO_DE_ZONA, payload: producto });
    }
}

export function removeProductoDeZona(producto) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_PRODUCTO_DE_ZONA, payload: producto });
    }
}


